import moment from 'moment'
import { seriesData, mergeCounts } from '../components/commonChartFunctions'

export default {
  data() {
    return {
      startDate: '',
      endDate: '',
      currentFilterType: 'whole_year',
      chartData: {},
      series: [{ name: 'sessions', data: [] }]
    }
  },
  mounted() {
    if (!this.filters.dateRange) {
      this.wholeYearRangeClicked()
    }
    this.updateDataAttributes()
  },
  watch: {
    currentFilterType: 'updateDataAttributes'
  },
  computed: {
    sumOfSessions() {
      return _.reduce(mergeCounts(this.chartData), (sum, val, key) => {
        if (moment(key).isBetween(this.startDate, this.endDate, null, '[]')) {
          return sum + val
        } else {
          return sum
        }
      }, 0)
    },
    pluralizedSessions() {
      return this.sumOfSessions === 1 ? 'session' : 'sessions'
    }
  },
  methods: {
    wholeYearRangeClicked() {
      this.startDate = moment(`${this.year_info.school_start_date}`)
      this.endDate = moment().endOf('day')
      this.currentFilterType = 'whole_year'
      this.setChartZoom()
    },
    sevenDayRangeClicked() {
      this.setDayRange(7, '7_days')
    },
    thirtyDayRangeClicked() {
      this.setDayRange(30, '30_days')
    },
    setDayRange(day, filterType) {
      this.startDate = moment().subtract(day, 'days').startOf('day')
      this.endDate = moment().subtract(1, 'days').endOf('day')
      this.currentFilterType = filterType
      this.setChartZoom()
    },
    setChartZoom() {
      this.$refs.apexChart?.zoomX(this.startDate?.valueOf(), this.endDate?.valueOf())
    },
    applyData(data) {
      this.chartData = data
      this.applyDateRangeBounds()
      this.$refs.apexChart.updateSeries([{ name: 'sessions', data: seriesData(mergeCounts(data)) }])
      this.$nextTick(this.setChartZoom)
    },
    updateDataAttributes() {
      const el = this.$el
      if (!el) return

      el.setAttribute('data-filter-type', this.currentFilterType)
    }
  }
}
